"use client";

import clsx from "clsx";
import type React from "react";
import SiteFooter from "src/components/app/SiteFooter/SiteFooter";
import Typography from "src/components/common/Typography/Typography";
import styles from "./StatusPage.module.scss";
import { useStatusPageLayout } from "./StatusPageLayoutContext";

export interface StatusPageProps {
  title: string;
  /** Large decorative artwork above the title, such as a status code. */
  art?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  /** `inline` fills a layout's content area instead of the whole window, without the site footer. */
  variant?: "page" | "inline";
}

const StatusPage = (props: StatusPageProps) => {
  const { title, art, children, actions } = props;
  const insideLayout = useStatusPageLayout();
  const variant = insideLayout ? "inline" : (props.variant ?? "page");
  const Content = variant === "inline" ? "div" : "main";
  return (
    <div className={clsx(styles.page, variant === "inline" && styles.inline)}>
      <Content className={styles.main}>
        {art ? (
          <div className={styles.art} aria-hidden={true}>
            {art}
          </div>
        ) : null}
        <Typography variant="heading1" className={styles.title}>
          {title}
        </Typography>
        <div className={styles.body}>{children}</div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </Content>
      {variant === "page" ? <SiteFooter className={styles.footer} /> : null}
    </div>
  );
};

export default StatusPage;
